import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-between my-8" }
const _hoisted_2 = { class: "text-22 font-medium text-black-900 tablet:text-26" }
const _hoisted_3 = { class: "flex items-center gap-x-18" }
const _hoisted_4 = {
  key: 0,
  class: "text-14 text-black-400 tablet:text-18"
}
const _hoisted_5 = {
  type: "button",
  class: "modal-popup__close"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString($props.locale.cart), 1),
    _createElementVNode("div", _hoisted_3, [
      ($props.itemsCount > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($props.itemsCount) + " " + _toDisplayString($props.itemsCount > 1 ? $props.locale.items : $props.locale.item), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", _hoisted_5, [
        _createVNode(_component_v_icon, {
          icon: "close",
          width: 11,
          height: 11
        })
      ])
    ])
  ]))
}